import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'services/user/types';
import { ThunkGetUser } from 'store/user/thunks';
import { RootState } from 'store/index';
import { signOut } from 'utils/session';

const initialState: Partial<IUser> = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearStore: state => {
      signOut();
      return {};
    },
  },
  extraReducers: builder => {
    builder.addCase(ThunkGetUser.fulfilled, (_, action) => {
      return action.payload;
    });
  },
});

export default userSlice.reducer;

export const { clearStore } = userSlice.actions;
export const UserDataSelector = (state: RootState): Partial<IUser> => state.user;
